import { Deserializable } from '../_common/deserializable';

export class Content implements Deserializable {
      id: number;
      name: string;
      description: string;
      createdAt: number;

    deserialize(input: any): this {
      return Object.assign(this, input);
    }
}
